import React from 'react';
interface TestimonialProps {
  author: string;
  location: string;
  quote: string;
}
export function TestimonialBox({
  testimonials
}: {
  testimonials: TestimonialProps[];
}) {
  return <div className="my-8 p-6 border-2 border-dashed border-gray-300 rounded-lg bg-blue-50/30 space-y-6" data-id="element-137">
      {testimonials.map((testimonial, index) => <blockquote key={index} className={index !== testimonials.length - 1 ? 'mb-6' : ''} data-id="element-138">
          <p className="text-base text-gray-800 mb-2 font-serif leading-relaxed" data-id="element-139">
            "{testimonial.quote}"
          </p>
          <footer className="text-sm font-bold text-gray-900" data-id="element-140">
            — {testimonial.author}, {testimonial.location}
          </footer>
        </blockquote>)}
    </div>;
}